import { getPhoneIdentityKey, isValidPhone, normalizePhoneForStorage } from "./phone";

export const CONTACT_IMPORT_HEADERS = ["שם מלא", "מספר טלפון"];

const cellText = (value) => String(value ?? "").trim();

export const createImportedContact = ({ name, phoneNumber }) => ({
  name,
  phoneNumber,
  status: "pending",
  needsRide: false,
  gift: "0",
  howMany: "1",
  dedication: "",
  tableNum: "",
});

export const parseContactImportRows = (rows) => {
  if (!Array.isArray(rows) || rows.length === 0) {
    return { contacts: [], duplicateRows: 0, errors: [{ row: 1, reason: "הקובץ ריק." }] };
  }

  const header = Array.isArray(rows[0]) ? rows[0] : [];
  const hasExpectedHeader = CONTACT_IMPORT_HEADERS.every(
    (expected, index) => cellText(header[index]) === expected
  );
  if (!hasExpectedHeader) {
    return {
      contacts: [],
      duplicateRows: 0,
      errors: [{ row: 1, reason: "כותרות הקובץ חייבות להיות: שם מלא | מספר טלפון." }],
    };
  }

  const contacts = [];
  const errors = [];
  const seenPhones = new Set();
  let duplicateRows = 0;

  rows.slice(1).forEach((rowValue, index) => {
    const row = Array.isArray(rowValue) ? rowValue : [];
    const excelRow = index + 2;
    const rawName = row[0];
    const rawPhone = row[1];
    const name = cellText(rawName);
    const phoneText = cellText(rawPhone);

    if (!name && !phoneText) return;
    if (!name) {
      errors.push({ row: excelRow, reason: "חסר שם מלא." });
      return;
    }
    if (!phoneText) {
      errors.push({ row: excelRow, reason: "חסר מספר טלפון." });
      return;
    }
    if (typeof rawPhone === "number") {
      errors.push({
        row: excelRow,
        reason: "מספר הטלפון נשמר באקסל כמספר ועלול לאבד אפס מוביל. יש לשמור אותו כטקסט.",
      });
      return;
    }

    const phoneNumber = normalizePhoneForStorage(phoneText);
    if (!isValidPhone(phoneNumber)) {
      errors.push({ row: excelRow, reason: "מספר הטלפון חייב להכיל 9–15 ספרות." });
      return;
    }

    const phoneKey = getPhoneIdentityKey(phoneNumber);
    if (seenPhones.has(phoneKey)) {
      duplicateRows += 1;
      return;
    }

    seenPhones.add(phoneKey);
    contacts.push(createImportedContact({ name, phoneNumber }));
  });

  if (contacts.length === 0 && errors.length === 0) {
    errors.push({ row: 2, reason: "לא נמצאו אנשי קשר בקובץ." });
  }

  return { contacts, duplicateRows, errors };
};

export const mergeImportedContactLists = (currentContactsValue, importedContactsValue) => {
  const currentContacts = Array.isArray(currentContactsValue) ? currentContactsValue : [];
  const importedContacts = Array.isArray(importedContactsValue) ? importedContactsValue : [];
  const existingPhones = new Set(
    currentContacts.map((contact) => getPhoneIdentityKey(contact.phoneNumber)).filter(Boolean)
  );
  const addedContacts = [];
  let existingDuplicates = 0;

  importedContacts.forEach((contact) => {
    const phoneKey = getPhoneIdentityKey(contact.phoneNumber);
    if (!phoneKey || existingPhones.has(phoneKey)) {
      existingDuplicates += 1;
      return;
    }
    existingPhones.add(phoneKey);
    addedContacts.push(contact);
  });

  return {
    contacts: [...currentContacts, ...addedContacts],
    addedCount: addedContacts.length,
    existingDuplicates,
  };
};
